import UnderwritingEngine from '../components/underwriting/UnderwritingEngine'
import useDealStore from '../store/dealStore'

function Module4Page() {
  const { dealState, updateDealState, updateAvailableModules, forceNavigateToModule } = useDealStore()

  const handleComplete = (results, scenario) => {
    // Build shared ownership-cost snapshot so every downstream module (5-16)
    // reads the same numbers from deal state instead of recomputing.
    const ownershipCosts = {
      monthlyInsurance: results.monthlyInsurance,
      annualInsurance: results.annualInsurance,
      insuranceIsEstimated: results.insuranceIsEstimated || false,
      monthlyPropertyOpEx: results.monthlyPropertyOpEx,
      annualPropertyOpEx: results.annualPropertyOpEx,
      monthlyPropertyTax: results.monthlyPropertyTax,
      annualPropertyTax: results.annualPropertyTax,
      monthlyDebtService: results.monthlyDebtService,
      annualDebtService: results.annualDebtService,
      totalMonthlyOwnershipCost: results.totalMonthlyOwnershipCost,
      totalAnnualOwnershipCost: results.totalAnnualOwnershipCost,
    }

    const operatingExpenseDetail = {
      annualInsurance: results.annualInsurance,
      monthlyInsurance: results.monthlyInsurance,
      insuranceIsEstimated: results.insuranceIsEstimated || false,
      annualPropertyTax: results.annualPropertyTax,
      monthlyPropertyTax: results.monthlyPropertyTax,
      annualPropertyOpEx: results.annualPropertyOpEx,
      monthlyPropertyOpEx: results.monthlyPropertyOpEx,
      totalAnnualExpenses: results.totalExpenses,
      totalMonthlyExpenses: Math.round(results.totalExpenses / 12),
    }

    updateDealState({
      ownershipCosts,
      underwritingMetrics: {
        ...dealState.underwritingMetrics,
        noi: results.noi,
        capRate: {
          entry: results.capRate,
          exit: scenario.exitCapRate,
          market: scenario.exitCapRate,
        },
        dscr: {
          current: results.dscr,
          minimum: 1.25,
          average: results.dscr,
        },
        irr: {
          unlevered: results.irr,
          levered: results.irr,
          holdingPeriod: scenario.holdYears,
        },
        cashOnCash: {
          year1: results.cashOnCash,
          average: results.cashOnCash,
          peak: results.cashOnCash,
        },
        roi: results.irr,
        breakEvenOccupancy: results.breakEvenOccupancy,
        debtService: {
          monthly: results.monthlyDebtService,
          annual: results.annualDebtService,
          interestRate: scenario.interestRate,
          loanAmount: Math.round(scenario.loanAmount),
          ltv: scenario.loanAmount / scenario.purchasePrice,
        },
        operatingExpenseDetail,
        scenarioAnalysis: {
          sensitivity: {},
          stressTest: {},
        },
        underwritingEngineDetails: {
          modelVersion: 'mvp-module-4',
          assumptionsUsed: [
            'purchasePrice', 'income', 'expenses', 'insurance',
            'vacancy', 'debtService', 'exitCapRate',
          ],
          riskFactors: results.dscr < 1.25 ? ['DSCR below lender threshold'] : [],
          confidenceLevel: 0.82,
        },
      },
    })

    updateAvailableModules()
    // Task 5: After Underwriting completes, go to Lender Match (Module 6)
    // (Deal Score now comes BEFORE underwriting in the flow)
    setTimeout(() => forceNavigateToModule(5), 600)
  }

  return <UnderwritingEngine dealState={dealState} onComplete={handleComplete} />
}

export default Module4Page
